import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface CardProps extends HTMLMotionProps<'div'> {
  children: React.ReactNode;
  variant?: 'default' | 'outline' | 'flat';
  hoverEffect?: boolean;
}
export function Card({
  children,
  variant = 'default',
  hoverEffect = true,
  className = '',
  ...props
}: CardProps) {
  const baseStyles = 'overflow-hidden';
  const variants = {
    default: 'bg-white border border-ink/10',
    outline: 'bg-transparent border border-ink/10',
    flat: 'bg-white/50 border-none'
  };
  const hoverStyles = hoverEffect ? 'hover:border-ink/20 transition-all duration-300' : '';
  return <motion.div className={`${baseStyles} ${variants[variant]} ${hoverStyles} ${className}`} initial={hoverEffect ? {
    y: 0
  } : undefined} whileHover={hoverEffect ? {
    y: -2
  } : undefined} transition={{
    type: 'spring',
    stiffness: 300,
    damping: 25
  }} {...props} data-id="element-187">
      {children}
    </motion.div>;
}